const VERSION_RELOAD_KEY = "g9_lexia_version_reload";
const REFRESH_QUERY = "_refresh";

const clearWebCaches = async () => {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
  } catch (error) {
    console.warn("Could not clear web caches before reload", error);
  }
};

export const reloadForNewWebVersion = async ({ force = false } = {}) => {
  if (!force && sessionStorage.getItem(VERSION_RELOAD_KEY) === "1") {
    return false;
  }

  sessionStorage.setItem(VERSION_RELOAD_KEY, "1");
  await clearWebCaches();

  const url = new URL(window.location.href);
  url.searchParams.set(REFRESH_QUERY, String(Date.now()));
  window.location.replace(url.toString());
  return true;
};

export const markWebVersionCurrent = () => {
  sessionStorage.removeItem(VERSION_RELOAD_KEY);

  const url = new URL(window.location.href);
  if (!url.searchParams.has(REFRESH_QUERY)) return;

  url.searchParams.delete(REFRESH_QUERY);
  const next = url.pathname + (url.searchParams.toString() ? `?${url.searchParams}` : "") + url.hash;
  window.history.replaceState({}, "", next);
};
